"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductList = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _List = _interopRequireDefault(require("../../../List"));

var _ProductLogos = _interopRequireDefault(require("../../ProductLogos/ProductLogos"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _ThemeHelper = require("../../../Utilities/ThemeHelper");

var _styles2 = require("@material-ui/core/styles");

var _Drawer = _interopRequireDefault(require("../../../Drawer"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ProductList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductList, _Component);

  var _super = _createSuper(ProductList);

  function ProductList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProductList);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ProductSuiteSort", function (a, b) {
      var aName = a.name.toLowerCase();
      var bName = b.name.toLowerCase();
      if (aName === bName) return 0;
      if (aName === "civicplusplatform") return -1;
      if (bName === "civicplusplatform") return 1;
      if (aName < bName) return -1;
      if (aName > bName) return 1;
      return 0;
    });
    _this.state = {
      isOpen: false,
      products: [{
        button: true,
        href: "https://platform.civicplus.com",
        itemText: {
          primary: _ProductLogos.default.civicplusplatform
        },
        isSideNav: true,
        isProductDropdown: true,
        className: props.classes.prodPlatform
      }]
    };
    return _this;
  }

  (0, _createClass2.default)(ProductList, [{
    key: "updateProductList",
    value: function () {
      var _updateProductList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$props$identityS,
            _this2 = this;

        var productList, productSuitesIndexed, productSuites, products;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (_this$props$identityS = this.props.identityServerSdk) === null || _this$props$identityS === void 0 ? void 0 : _this$props$identityS.GetClientListAsync();

              case 2:
                productList = _context.sent;

                if (productList && productList.length > 0) {
                  productSuitesIndexed = {};
                  productSuites = [];
                  productList.forEach(function (product) {
                    if (!productSuitesIndexed[product.type.suite.id]) {
                      productSuitesIndexed[product.type.suite.id] = {
                        id: product.type.suite.id,
                        name: product.type.suite.name,
                        suiteUri: product.productUri,
                        products: []
                      };
                      productSuites.push(productSuitesIndexed[product.type.suite.id]);
                    }

                    productSuitesIndexed[product.type.suite.id].products.push({
                      name: product.name,
                      productUri: product.productUri
                    });
                  });
                  productSuites.sort(this.ProductSuiteSort);
                  products = [];
                  productSuites.forEach(function (suite) {
                    products.push({
                      button: true,
                      href: suite.suiteUri,
                      itemText: {
                        primary: _ProductLogos.default[suite.name.toLowerCase().replace(/ /g, "")]
                      },
                      isSideNav: true,
                      isProductDropdown: true,
                      className: _this2.props.classes[suite.name.toLowerCase().replace(/ /g, "")]
                    });
                    suite.products.forEach(function (product) {
                      products.push({
                        button: true,
                        href: product.productUri,
                        itemText: {
                          primary: product.name
                        },
                        isSideNav: true,
                        isProductDropdown: true,
                        className: _this2.props.classes[suite.name.toLowerCase().replace(/ /g, "")]
                      });
                    });
                  });
                  this.setState({
                    products: products
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateProductList() {
        return _updateProductList.apply(this, arguments);
      }

      return updateProductList;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(prevProps, prevState) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(prevProps.identityServerSdk !== this.props.identityServerSdk)) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.updateProductList();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x, _x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.props.identityServerSdk) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.updateProductList();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          classes = _this$props.classes,
          open = _this$props.open,
          onToggle = _this$props.onToggle,
          offsetTop = _this$props.offsetTop,
          disableSidebar = _this$props.disableSidebar,
          className = _this$props.className;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        id: id,
        open: open,
        className: (0, _classnames.default)(classes.rootWrapper, (0, _defineProperty2.default)({}, classes.rootWrapperOpen, open)),
        classes: {
          paper: (0, _classnames.default)(className, classes.root, {
            "prmbl-ProductList-offsetTop": offsetTop
          })
        },
        onClose: onToggle,
        modalProps: {
          BackdropProps: {
            invisible: true
          },
          className: classes.modal
        },
        SlideProps: {
          unmountOnExit: true
        },
        anchor: "top",
        variant: offsetTop || disableSidebar ? "temporary" : "persistent"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.menu
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.title
      }, /*#__PURE__*/_react.default.createElement("span", null, "Products")), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.wrapper
      }, /*#__PURE__*/_react.default.createElement(_List.default, {
        "aria-label": "Products",
        id: id,
        sideNav: true,
        listItems: this.state.products
      })), /*#__PURE__*/_react.default.createElement(_Button.default, {
        href: "https://www.civicplus.com/integrated-technology-platform",
        openInNewWindow: true,
        fullWidth: true,
        className: classes.button
      }, "View Additional Products"))), offsetTop ? /*#__PURE__*/_react.default.createElement("style", null, "\n\t\t\t\t\t.prmbl-ProductList-offsetTop {\n\t\t\t\t\t\ttop: ".concat(offsetTop, ";\n\t\t\t\t\t\theight: calc(100% - ").concat(offsetTop, ")\n\t\t\t\t\t}")) : undefined);
    }
  }]);
  return ProductList;
}(_react.Component);

exports.ProductList = ProductList;
(0, _defineProperty2.default)(ProductList, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * `true` if the ProductList is open
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The callback to fire when toggling the component
   */
  onToggle: _propTypes.default.func.isRequired,

  /**
   * The html node to render as the product logo
   */
  productLogo: _propTypes.default.node,

  /**
   * The identitySeverSdk object. Requires accessToken, identityServerBaseUrl, and idToken.
   * Used to get the user's products and information.
   *
   * If no user is specified, a blank product list will be shown and a user avatar will be hidden.
   */
  identityServerSdk: _propTypes.default.object,

  /**
   * The current organization's name
   */
  currentOrg: _propTypes.default.string,

  /**
   * The current organization's branding settings
   */
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),

  /**
   * The type of page, which affects what logo and color is used
   */
  type: _propTypes.default.oneOf(["internal", "external"]),

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(Object.keys(_ThemeHelper.themes)),

  /**
   * The height to open the menu to, offset from the top of the page. Include unit (px, em, %, etc)
   */
  offsetTop: _propTypes.default.string,

  /**
   * If `true` the side bar will not be displayed
   */
  disableSidebar: _propTypes.default.bool,

  /**
   * @ignore
   */
  className: _propTypes.default.string
});

var _default = (0, _styles2.withStyles)(_styles.styles)(ProductList);

exports.default = _default;